// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1o-0";
export var spinnerContainer = "_1o-1";